module.exports = __webpack_public_path__ + "static/media/drink.2699e1d4.svg";